export default __webpack_public_path__ + "f3a94ee1d2ffe8ff9d6ce5723a0fd188.svg";